/* eslint-disable react/jsx-props-no-spreading */
import { Message as ChromaMessage } from '@iag-packages/chroma-react/lib/components';
import React from 'react';
import styled from 'styled-components';
import THEME from 'theme';

const MessageWrapper = styled.div`
  .c-icon {
    color: ${THEME.LINK.DEFAULT} !important;
  }
`;

export const Message = ({ ...props }) => (
  <MessageWrapper>
    <ChromaMessage {...props} />
  </MessageWrapper>
);

export default Message;
